export default {
  activateLandingPageTitle: 'الفعاليات',
  activateProductCardTitle: 'الفعاليات',
  activateProductPageTitle: 'حجز الفعاليات',
  allProductsLandingPageTitle: 'احجز تجارب فريدة',
  apply: 'تطبيق',
  buyTickets: 'شراء التذاكر',
  cancel: 'إلغاء',
  clear: 'مسح',
  clearFilters: 'مسح المرشحات',
  discoverExperiences: 'اكتشف التجارب',
  exclusive: 'حصري',
  experience: 'تجربة',
  experiencePhotoOfListing:
    'صورة التجربة {{photoNumber}} من القائمة {{listingTitle}}',
  experiences: 'تجارب',
  experiencesFoundCount: 'تم العثور على {{count}} تجربة',
  filterExperiences: 'تصفية التجارب',
  fromListingCard: 'من',
  hostedBy: 'يستضيفها',
  hostLandingPageTitle: 'التجارب المحلية',
  hostProductCardTitle: 'التجارب المحلية',
  hostProductPageTitle: 'حجز التجارب المحلية',
  landingPageTitle: 'احجز تجارب فريدة',
  mainLandingPageTitle: 'جميع التجارب',
  more: 'المزيد',
  noExperiencesFound: 'لم يتم العثور على تجارب',
  noExperiencesFoundFor: 'لم يتم العثور على تجارب لـ',
  profileImageOfHost: 'الصورة الشخصية للمضيف {{hostName}}',
  reserve: 'حجز',
  reserveLandingPageTitle: 'الأنشطة والمرافق',
  reserveProductCardTitle: 'الأنشطة',
  reserveProductPageTitle: 'حجز الأنشطة والمرافق',
  resultsPageTitle: 'حجز التجارب والأنشطة',
};
